import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import Footer from '@/components/common/Footer';

export function PublicLayout({ children }: { children: React.ReactNode }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div data-theme="swayam-preview" className="public-page-shell">
      <button
        onClick={toggleTheme}
        className="login-theme-toggle"
        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      </button>

      <main className="login-main">
        {children}
      </main>

      <Footer />
    </div>
  );
}
